"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "serra-ricco": {
    "195e9535": [{
      "hkey": "a8249261",
      "slug": "orero-costa-crocetta",
      "name": "Orero-Costa-Crocetta",
      "primary": true,
      "skipSearch": false
    }],
    "costa-fontana": [{
      "hkey": "a8249261",
      "slug": "orero-costa-crocetta",
      "name": "Orero-Costa-Crocetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "serra-ricco"
    }],
    "c8506363": [{
      "hkey": "a8249261",
      "slug": "orero-costa-crocetta",
      "name": "Orero-Costa-Crocetta",
      "primary": true,
      "skipSearch": false
    }],
    "crocetta": [{
      "hkey": "a8249261",
      "slug": "orero-costa-crocetta",
      "name": "Orero-Costa-Crocetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "serra-ricco"
    }],
    "f1e349b9": [{
      "hkey": "a8249261",
      "slug": "orero-costa-crocetta",
      "name": "Orero-Costa-Crocetta",
      "primary": true,
      "skipSearch": false
    }],
    "orero-chiesa": [{
      "hkey": "a8249261",
      "slug": "orero-costa-crocetta",
      "name": "Orero-Costa-Crocetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;